import { render, staticRenderFns } from "./QuestionHeader.vue?vue&type=template&id=6cf2aeda&"
import script from "./QuestionHeader.vue?vue&type=script&lang=js&"
export * from "./QuestionHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VStepperStep})
